export default __webpack_public_path__ + "static/possibl-logo-4f10acf181a9b6a94b20c62f9e2892b7.png";